import React, { useState, useEffect, useRef } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";

// Smart API URL switching
const API_BASE_URL =
    window.location.hostname === "staging187611.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : window.location.hostname === "digassistant.xyz" || window.location.hostname === "www.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : "http://localhost:8080";

const LoginPage = () => {
    const navigate = useNavigate();
    const [isProcessing, setIsProcessing] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [videoFailed, setVideoFailed] = useState(false);
    const videoRef = useRef(null);

    useEffect(() => {
        fetch(`${API_BASE_URL}/auth/check`, { credentials: "include" })
            .then((res) => res.json())
            .then((data) => {
                if (data.verified === false) navigate("/verify");
                else if (data.authenticated) navigate("/service");
            })
            .catch(() => {});
    }, [navigate]);

    useEffect(() => {
        const video = videoRef.current;
        if (!video || videoFailed) return;
        const playPromise = video.play();
        if (playPromise !== undefined) {
            playPromise.catch(() => setVideoFailed(true));
        }
    }, [videoFailed]);

    const handleLoginSuccess = async (credentialResponse) => {
        setIsProcessing(true);
        setFormErrors({});

        try {
            const res = await fetch(`${API_BASE_URL}/auth/google/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token: credentialResponse.credential }),
                credentials: "include",
            });

            if (res.ok) {
                navigate("/service");
            } else {
                const errorMessage = await res.text();
                console.error("Login Failed:", errorMessage);
                setFormErrors({ general: errorMessage || "Login failed. Please try again." });
                setIsProcessing(false);
            }
        } catch (error) {
            console.error("❌ Login error:", error);
            setFormErrors({ general: "Network error. Please try again." });
            setIsProcessing(false);
        }
    };

    const handleLoginError = () => {
        console.error("❌ Google Login Failed.");
        setFormErrors({ general: "Google login failed. Please try again." });
    };

    if (isProcessing) {
        return (
            <div className="login-format" style={{ padding: "20px", textAlign: "center" }}>
                <div style={{ width: "fit-content", margin: "0 auto" }}>
                    <h1>Processing login...</h1>
                    <p>Please wait while we verify your credentials.</p>
                </div>
            </div>
        );
    }

    return (
        <div style={{
            minHeight: '100vh',
            ...(videoFailed && {
                backgroundImage: 'url("https://storage.googleapis.com/tmhimagebucket/lathedubplate.jpg")',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }),
            position: 'relative',
            overflow: 'hidden'
        }}>
            {!videoFailed && (
                <video
                    ref={videoRef}
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="auto"
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        minWidth: '100%',
                        minHeight: '100%',
                        width: 'auto',
                        height: 'auto',
                        transform: 'translate(-50%, -50%) scale(0.45)',
                        objectFit: 'cover',
                        zIndex: 0
                    }}
                >
                    <source src="https://storage.googleapis.com/tmhimagebucket/clip2compdouble.mp4" type="video/mp4" />
                </video>
            )}
            <div style={{
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                zIndex: 1
            }} />
            <div className="App" style={{ position: 'relative', zIndex: 2 }}>
                <div className="about-section" style={{ textAlign: 'center' }}>
                    <>
                            <h2>Timehri Dig Assistant</h2>
                            <p style={{ marginBottom: '30px' }}>Traverse the depths of Discogs instantly</p>

                            {formErrors.general && (
                                <div style={{ color: "red", fontSize: "12px", marginBottom: "20px", fontFamily: 'CustomFont' }}>
                                    {formErrors.general}
                                </div>
                            )}
                            <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'center', width: '100%' }}>
                                <GoogleLogin
                                    onSuccess={handleLoginSuccess}
                                    onError={handleLoginError}
                                    text="continue_with"
                                    size="large"
                                    width="200"
                                />
                            </div>
                            <span
                                onClick={() => navigate("/passwordless-login")}
                                style={{
                                    color: 'rgba(255,255,255,0.7)',
                                    fontSize: '13px',
                                    fontFamily: 'CustomFont',
                                    cursor: 'pointer',
                                    textDecoration: 'underline',
                                }}
                            >
                                or register / login with email
                            </span>
                    </>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
